import { keyframes } from 'glamor'
import { colors, settings } from '@dooer/react-ui-kit'
import { colorFromScore } from '../../utils'

const bounce = keyframes('bounce', {
  '0%': { transform: 'translateY(0)' },
  '50%': { transform: 'translateY(-5px)' },
  '100%': { transform: 'translateY(0)' },
})

export default {
  root: {
    marginBottom: settings.spacing.medium,
  },
  number: (isSelected: boolean, i: number, includeColors?: boolean) => ({
    color: includeColors ? 'white' : isSelected ? 'white' : colors.text,
    background: includeColors
      ? isSelected
        ? colors.backgrounds.dark
        : colorFromScore(i)
      : isSelected && colors.backgrounds.dark,
    border: !includeColors && (isSelected ? `1px solid ${colors.backgrounds.dark}` : `1px solid #BBB`),
    fontSize: settings.typography.sizes.large,
    lineHeight: '100%',
    height: settings.spacing.xLarge,
    width: settings.spacing.xLarge,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    transition: settings.transitions.regularFast,
    userSelect: 'none',
    cursor: 'pointer',
    boxShadow: includeColors && isSelected && settings.shadows.elevation,
    transform: includeColors && isSelected && 'scale(1.2)',
    animation: isSelected && `${bounce} 2s infinite`,
    transformOrigin: 'center',
    position: 'relative',
    fontWeight: settings.typography.weights.semibold,

    '@media(max-width: 500px)': {
      height: '40px',
      width: '26px',
      fontSize: '19.2px',
      borderRadius: '3px',
    },

    '&:hover': {
      opacity: !isSelected && '0.75',
      transition: !isSelected && settings.transitions.regularFast,
    },

    '&:focus': {
      outline: 'none',

      '&:after': {
        content: "''",
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: '110%',
        width: '110%',
        backgroundColor: 'none',
        border: `2px solid ${colors.borders.primary}`,
        borderRadius: '50%',
      },
    },
  }),
  helper: {
    backgroundColor: colors.backgrounds.primary,
    borderRadius: settings.borderRadiuses.regular,
    padding: `${settings.spacing.xSmall} ${settings.spacing.small}`,
    userSelect: 'none',

    '> span': {
      display: 'block',
      fontSize: '14px',
      letterSpacing: '0.25px',

      '> i': {
        padding: '0 0.25rem',
      },
    },
  },
}
